<template>

    <div class="help">

        <help-content></help-content>

    </div>

</template>

<script>
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import HelpContent from '../components/help/HelpContent.vue'

export default {

    // HelpPage is a container for "HelpContent" component in "desktop mode"
    name: 'help-page',

    components: {
        HelpContent
    },

    computed: {


    },

    mounted() {
        Tag.pageViewGA(this, 'help')
        UserFlow.setPage(this, 'help')
    }
}
</script>

<style lang="scss" scoped>

.help {
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
    }
}

</style>
